export { SectionHeading } from './styled';
